import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Shield, BarChart3, Video, Users, FileText, Building2, ArrowUpRight } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const SERVICES = [
{ icon: Shield, title: "Tenant Sourcing & Verification", desc: "Rigorous background checks, income verification, and legally airtight lease agreements for every tenant.", accent: "emerald" },
{ icon: BarChart3, title: "Rent Collection & Analytics", desc: "Automated rent collection with monthly performance summaries and property analytics sent directly to you.", accent: "emerald" },
{ icon: Video, title: "Video Updates & Reporting", desc: "Regular on-ground video walkthroughs, detailed maintenance reports, and comprehensive property health insights.", accent: "gold" },
{ icon: Users, title: "Maintenance Coordination", desc: "End-to-end maintenance management with trusted, vetted vendors zero hassle on your end.", accent: "emerald" },
{ icon: FileText, title: "Legal & POA Support", desc: "Full legal assistance including Power of Attorney management, compliance, and documentation.", accent: "gold" },
{ icon: Building2, title: "Asset Acquisition & Disposition", desc: "Expert guidance in buying and selling properties, backed by 25+ years of market intelligence.", accent: "emerald" }];


export function ServicesOverview() {
  return (
    <section className="relative overflow-hidden py-32" data-testid="services-section">
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-stone-50 to-white" />
      <div className="container-luxury">
        <SectionHeading eyebrow="What We Do" title="Every Detail, Handled" titleAccent="with Precision" subtitle="From sourcing the right tenant to managing day-to-day operations and keeping you informed with radical transparency — we cover it all." />

        <div className="mt-20 grid gap-px bg-navy-100/50 sm:grid-cols-2 lg:grid-cols-3 rounded-2xl overflow-hidden shadow-luxury">
          {SERVICES.map((service, i) => {
            const Icon = service.icon;
            return (
              <Reveal key={service.title} delay={i * 0.05}>
                <div className="group relative flex flex-col gap-5 bg-white p-8 lg:p-10 hover:bg-stone-50 transition-colors duration-300 h-full">
                  <div className={`inline-flex h-12 w-12 items-center justify-center rounded-xl ${service.accent === "gold" ? "bg-gold-50 text-gold-600" : "bg-emerald-50 text-emerald-500"}`}>
                    <Icon size={22} strokeWidth={1.5} />
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-navy-800 tracking-tight">{service.title}</h3>
                    <p className="mt-2.5 text-sm leading-relaxed text-navy-600/70">{service.desc}</p>
                  </div>
                  <div className="mt-auto pt-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <ArrowUpRight size={16} className="text-emerald-500" />
                  </div>
                </div>
              </Reveal>);

          })}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-12 text-center">
            <Link to="/services" className="group inline-flex items-center gap-2 text-sm font-medium text-navy-700 hover:text-navy-900 transition-colors">
              Explore all services & pricing
              <motion.span className="inline-block" animate={{ x: [0, 4, 0] }} transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}>→</motion.span>
            </Link>
          </div>
        </Reveal>
      </div>
    </section>);

}